// extracted by mini-css-extract-plugin
export var cdFooter = "footer-module--cd-footer--52560";
export var cdFooterBottom = "footer-module--cd-footer-bottom--4cda3";
export var cdFooterBottomContent = "footer-module--cd-footer-bottom-content--11b1c";
export var cdFooterDarkLogo = "footer-module--cd-footer-dark-logo--6ee84";
export var cdFooterImg = "footer-module--cd-footer-img--ce91c";
export var cdFooterMarketSwitcher = "footer-module--cd-footer-market-switcher--bf813";
export var cdFooterMiddle = "footer-module--cd-footer-middle--b739d";
export var cdFooterMiddleContent = "footer-module--cd-footer-middle-content--34e6f";
export var cdFooterMiddleItem = "footer-module--cd-footer-middle-item--a92d6";
export var cdFooterMobileBottom = "footer-module--cd-footer-mobile-bottom--10c90";
export var cdFooterMobileBottomCopyright = "footer-module--cd-footer-mobile-bottom-copyright--86b27";
export var cdFooterMobileBottomItem = "footer-module--cd-footer-mobile-bottom-item--b9503";
export var cdFooterNavList = "footer-module--cd-footer-nav-list--21ed7";
export var cdFooterSubscribe = "footer-module--cd-footer-subscribe--a2043";
export var cdFooterTabContent = "footer-module--cd-footer-tab-content--463b0";
export var cdFooterTabTop = "footer-module--cd-footer-tab-top--432b9";
export var cdFooterTabs = "footer-module--cd-footer-tabs--5e5ff";
export var cdFooterWhiteLogo = "footer-module--cd-footer-white-logo--7eae6";
export var footerTabs = "footer-module--footer-tabs--e64d0";